
<div class="loading-screen-wrapper"  *ngIf="!showTable && !showThisInnerLoading" [ngStyle]="customStyle" [style.width]="currentWidth" [style.left]="backDropLeft" [class.scrolled]="isScrolled" [class.childloader]="isChildLoader" [class.allignNarrowComponent]="allignNarrowComponent" [class.allignSideBar]="allignSideBar" [class.allignFirstChildComponent]="allignFirstChildComponent" [class.isChildLoaderPayment]="isChildLoaderPayment" [class.scrollAfterLoading]="scrollAfterLoading" [class.isRenewDetail]="isRenewDetail" [class.makePaymentInReporting]="makePaymentInReporting">
  <div class="loader" ></div>
</div>
<div class="inner-subBlock-wrapper" *ngIf="showTable">
  <div class="shared-outer-wrapper">
     <table style="width:100%">
       <thead>
          <tr class="row loading-title-wrapper">
             <th class="col blur_header"><span class="blur_text animated bounce"></span></th>
             <th class="col blur_header"><span class="blur_text animated bounce"></span></th>
             <th class="col blur_header"><span class="blur_text animated bounce"></span></th>
             <th class="col blur_header"><span class="blur_text animated bounce"></span></th>
          </tr>
       </thead>
       <tbody>
         <tr class="row loading-content-wrapper">
           <td class="col-md blur_body"><span class="blur_text animated bounce"></span></td>
           <td class="col-md blur_body"><span class="blur_text animated bounce"></span></td>
           <td class="col-md blur_body"><span class="blur_text animated bounce"></span></td>
           <td class="col-md blur_body"><span class="blur_text animated bounce"></span></td>
         </tr>
         <tr class="row loading-content-wrapper">
            <td class="col-md blur_body"><span class="blur_text animated bounce"></span></td>
            <td class="col-md blur_body"><span class="blur_text animated bounce"></span></td>
            <td class="col-md blur_body"><span class="blur_text animated bounce"></span></td>
            <td class="col-md blur_body"><span class="blur_text animated bounce"></span></td>
          </tr>
       </tbody>
     </table>
  </div>
</div>

<div class="inner-loading-wrapper" *ngIf="showThisInnerLoading">
  <div class="loader" ></div>
</div>